<template>
  <div class="bread_crumb">
    <div class="bread_crumb_inner">
      <a href="" class="home">홈</a>
      <a href="">마이페이지</a>
      <a>SNS연결설정</a>
    </div>
  </div>
  <main id="main">
    <div class="contents">
      <div class="mypage_wrap">
        <MyHeader />
        <div class="mypage_body">
          <MySideBar />
          <EditProfileForm />
        </div>
      </div>
    </div>
  </main>
  <MainSideBar />
</template>
<script>
import MainSideBar from "../../layout/navigation/MainSideBar.vue";
import MyHeader from "../layout/MyHeader.vue";
import MySideBar from "../layout/MySideBar.vue";
import EditProfileForm from "@/components/mypage/privacyManagement/EditProfileForm.vue";

export default {
  components: {
    MainSideBar,
    MyHeader,
    MySideBar,
    EditProfileForm,
  },
};
</script>
<style lang=""></style>
